import type { TeamSpace } from "@prismicio/editor-fields"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import { useTeamSpaces } from "../../app/services/role"
import { TeamSpaceSettingsTab } from "./TeamSpacesDialogTabs"

const spaceSettingsParam = "spaceSettings"
const spaceSettingsTabParam = "spaceSettingsTab"

/**
 * Deep linking support via search params for Team Space Settings dialog.
 * Example:
 * `?spaceSettings=main&spaceSettingsTab=roles`
 * - opens main space settings with roles tab selected
 */
export function useTeamSpaceSettingsDeepLink() {
  const [searchParams, setSearchParams] = useSearchParams()

  const teamSpaceId = searchParams.get(spaceSettingsParam)

  const teamSpaces = useTeamSpaces()

  const teamSpace = teamSpaceId
    ? teamSpaces.find((teamSpace) => teamSpace.id === teamSpaceId)
    : undefined

  const tab = TeamSpaceSettingsTab.parse(
    searchParams.get(spaceSettingsTabParam),
  )

  function useOpenSettings(openSettings: (teamSpace: TeamSpace) => void) {
    useEffect(() => {
      if (teamSpace) openSettings(teamSpace)
    }, [openSettings])
  }

  function cleanupSearchParams() {
    if (
      searchParams.has(spaceSettingsParam) ||
      searchParams.has(spaceSettingsTabParam)
    ) {
      searchParams.delete(spaceSettingsParam)
      searchParams.delete(spaceSettingsTabParam)
      setSearchParams(searchParams, { replace: true })
    }
  }

  return {
    tab,
    useOpenSettings,
    cleanupSearchParams,
  }
}
